import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Кнопки на сцене.
//
// Первичная — единственная, у кого есть заливка и собственное свечение: она
// светит, значит она источник, значит она главная. Всё остальное — стекло
// разной плотности. Правило «одно первичное действие на экран» держится не
// договорённостью, а тем, что второе такое же сразу видно как ошибку.
//
// Отклик на нажатие даёт .lp-press: меняются только opacity и transform, то
// есть границы блока остаются на месте и соседи не дёргаются.
const buttonVariants = cva(
  "lp-press inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[14px] text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-[0_12px_28px_-14px_hsl(var(--primary)/0.95)] hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-[0_12px_28px_-14px_hsl(var(--destructive)/0.9)] hover:bg-destructive/90",
        outline:
          "lp-tile !rounded-[14px] text-foreground",
        secondary:
          "lp-tile !rounded-[14px] text-foreground",
        ghost: "text-foreground hover:bg-[var(--lp-tile)]",
        link: "text-link underline-offset-4 hover:underline",
      },
      size: {
        // 44px — не «покрупнее», а нижняя граница уверенного попадания
        // большим пальцем. Ниже неё промахи начинают стоить транзакций.
        default: "h-11 px-5 py-2",
        sm: "h-9 rounded-[12px] px-3.5 text-xs",
        lg: "h-12 rounded-[16px] px-8 text-base",
        icon: "h-11 w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
